import Menu from './Compartido/Menu.jsx';
import CabeceraTipoBarco from './TipoBarco/CabeceraTipoBarco.jsx';
import Barcos from './TipoBarco/Barcos.jsx';
import Bajo from './TipoBarco/Bajo.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const TipoBarco = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina={"tipo_" + props.eltipo.id}
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />

            <CabeceraTipoBarco
                lang={props.lang}
                eltipo={props.eltipo}
            />

            <Barcos
                lang={props.lang}
                barcos={props.propiedades}
                ruta={props.ruta}
                eltipo={props.eltipo}
            />

            <Bajo
                lang={props.lang}
                eltipo={props.eltipo}
            />

            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default TipoBarco;

